import React, { useState } from "react"
import { Button, Input, Modal } from "antd"
import { FolderAddOutlined } from "@ant-design/icons"

const GetInputModal = ({
  currentPath,
  onOk,
}: {
  currentPath: string
  onOk: any
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [directoryName, setDirectoryName] = useState("")

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleOk = async () => {
    setIsModalVisible(false)
    await onOk(directoryName)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  return (
    <div>
      <Modal
        title="Add Directory"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        {currentPath && (
          <p style={{ marginTop: "-10px" }}>
            Current path: <b>{currentPath}</b>
          </p>
        )}
        <Input
          placeholder="Directory Name"
          value={directoryName}
          onChange={(event) => setDirectoryName(event.target.value)}
        />
      </Modal>
      <Button
        size={"small"}
        style={{ marginTop: -1, background: "white" }}
        onClick={showModal}
        type={"text"}
      >
        <FolderAddOutlined style={{ color: "black" }} />
      </Button>
    </div>
  )
}

export default GetInputModal
